import React from "react"
import { has } from "lodash"

import ImageForm from "./ImageForm"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSave, faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons"

class ConfigurationForm extends React.Component{
    constructor(){
        super()
        this.state = {
            appName: "",
            appNameError: "",
            packageName: "",
            supportEmail: "",
            supportEmailError: "",
            loadingTips: "",
            loadingTipsError: "",

            approved: null,
            savedMessage: ""
        }
        this.textArea = React.createRef()
        this.whiteSpaceTest = /^\s+$/
        this.appNameTest = /[\w\d\.\ ]+/
        this.emailTest = /^\S+@\S+\.\S+$/
    }
    checkEmpty = (string) =>{
        return string === "" || this.whiteSpaceTest.test(string)
    }
    //main handleChange for the text area
    handleChange = (e) =>{
        const {name, value} = e.target
        const textAreaChange = e.target.name === "loadingTips"
        this.setState({
            [name]: value,
            appNameError: "",
            supportEmailError: "",
            loadingTipsError: "",
            appIconError: "",
            loadingIconError: "",
            savedMessage: ""
        }, ()=>{
            if(textAreaChange) this.changeTextAreaHeight()
        })
    }
    validate = () => {
        //app name validation
        if (this.checkEmpty(this.state.appName)){
            this.setState({appNameError:"App name is empty!"})
            return false
        }
        else if(!this.appNameTest.test(this.state.appName)){
            this.setState({appNameError:"App name can only consist of letters, numbers, and spaces"})
            return false
        }
        else if (this.state.appName.length > 30){
            this.setState({appNameError: "App name cannot be longer than 30 characters!"})
            return false
        }
        //support email validation
        if (this.checkEmpty(this.state.supportEmail)){
            this.setState({supportEmailError:"Email name is empty!"})
            return false  
        }
        else if (!this.emailTest.test(this.state.supportEmail)){
            this.setState({supportEmailError: "Please enter a proper email!"})
            return false
        }
        return true
    }
    handleSubmit = (e) =>{
        e.preventDefault()
        if (this.validate()){
            const { id } = this.props.appConfig[0]
            const { appName, supportEmail, loadingTips } = this.state
            fetch(`/api/data/project/${this.props.projectId}/appConfig/${id}`,{
                method: "PATCH",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    appName: appName,
                    supportEmail: supportEmail,
                    loadingTips: loadingTips.trim()
                })
            })
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")){ throw data }
                this.setState({
                    savedMessage: <><FontAwesomeIcon icon={faCheckCircle} /> Saved!</>
                    }, this.props.getAppConfig
                )}
            )
            .catch(data => this.setState({appNameError: `Server: ${data.error}`}))
        }
    }
    changeTextAreaHeight = () =>{
        this.textArea.current.style.height = (this.textArea.current.scrollHeight + 2) + "px"
    }
    updateState = () =>{
        const { appConfig } = this.props
        this.setState({
            appName: appConfig[0].appName,
            packageName: appConfig[0].packageName,
            supportEmail: appConfig[0].supportEmail === null ? "" : appConfig[0].supportEmail,
            loadingTips: appConfig[0].loadingTips === null ? "" : appConfig[0].loadingTips.data.reduce((prev, current)=>
                                                        prev + String.fromCharCode(current)
                                                    ,""),
            approved: appConfig[0].approved
        }, ()=>setTimeout(()=>this.changeTextAreaHeight(), 1))
    }
    componentDidMount(){
        this.updateState()
    }
    componentDidUpdate(prevProps){
        if (prevProps.appConfig !== this.props.appConfig){
            this.updateState()
        }
    }
    render(){
        const { appName, appNameError,
            packageName,
            supportEmail, supportEmailError, 
            loadingTips, loadingTipsError} = this.state
        return(
            <form className="requestForm">
                <div className="formWrapper">
                    <div className="formEntry">
                        <h3>Your App's Name:</h3>
                        <div className="inputContainer">
                            <input type="text" name="appName" value={appName} 
                            onChange={this.handleChange}
                            placeholder="A cool name! Less then 30 characters"/>
                            <p className="error">{appNameError}</p>
                        </div>
                    </div>
                    <div className="formEntry">
                        <h3>Package Name:</h3>
                        <h3 className="immutable inputContainer">{packageName}</h3>
                    </div>
                    <div className="formEntry">
                        <h3>Support Email:</h3>
                        <div className="inputContainer">
                            <input type="text" name="supportEmail" value={supportEmail} 
                            onChange={this.handleChange}
                            placeholder="Email for player support!"/>
                            <p className="error">{supportEmailError}</p>
                        </div>
                    </div>
                    <div className="formEntry">
                        <h3>
                            Loading Tips
                            <div className="warningContainer notice">
                                <FontAwesomeIcon className="warningIcon" icon={faExclamationCircle} />
                                <span className="warning">For multiple tips, Put each tip on its own line</span>
                            </div>
                        </h3>
                        <div className="inputContainer">
                            <textarea ref={this.textArea} id="textArea" 
                                onChange={this.handleChange}
                                value={loadingTips}
                                name="loadingTips" placeholder="Each line is one tip. Put as may tips as you like!" 
                                style={{height: "70px"}}/>
                            <p className="error">{loadingTipsError}</p>
                        </div>         
                    </div>
                </div>
                <div className="saveContainer">
                    <div className="save">
                        <button className="saveBtn" onClick={this.handleSubmit}>
                            <FontAwesomeIcon icon={faSave} />&nbsp;
                            Save!
                        </button>
                        <div className="savedMessage">
                            {this.state.savedMessage}
                        </div>
                    </div>
                </div>
                <ImageForm projectId={this.props.projectId} appConfig={this.props.appConfig} 
                    getAppConfig={this.props.getAppConfig}/>
            </form>
        )
    }
}

export default ConfigurationForm